<template>
    <v-switch
        v-model="formSwitch"
        v-bind="$attrs"
        :label="mandatory && label ? `${$root.defaultMandatoryAsteriks} ${label} ` : label || ''"
        :error-messages="errorMessage"
        :disabled="isReadonly || $attrs.disabled"
        v-on="$listeners"
        @change="resetErrorMessage($event)"
    >
        <template #label>
            <span @click.prevent.stop>{{
                mandatory && label ? `${$root.defaultMandatoryAsteriks} ${label} ` : label || ''
            }}</span>
        </template>
    </v-switch>
</template>

<script>
export default {
    name: 'BSwitch',
    props: {
        toMutate: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
        mandatory: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            store: null,
            propertyToMutate: null,
        };
    },

    computed: {
        formSwitch: {
            get() {
                return _.get(this.$store.state[this.store], this.propertyToMutate);
            },
            set(value) {
                this.$store.dispatch(`${this.store}/updateProperty`, { value, property: this.propertyToMutate });
            },
        },
        errorMessage() {
            return _.get(this.$store.state[this.store].errorMessages, this.propertyToMutate);
        },
        isReadonly() {
            if (typeof this.$attrs.readonly !== 'undefined') {
                return this.$attrs.readonly;
            }

            if (this.filters) {
                return false;
            }

            if (this.forceReadonly) {
                return true;
            }

            const propertyToMutate = this.propertyToMutate.toString().split('.').slice(-2).join('.');

            if (!is_writeable(propertyToMutate)) {
                return true;
            }

            return false;
        },
    },
    created() {
        [this.store, this.propertyToMutate] = this.toMutate.split('::');
    },
    methods: {
        resetErrorMessage() {
            if (this.errorMessage) {
                this.$store.commit(`${this.store}/SET_ERROR_MESSAGE`, {
                    value: [],
                    property: this.propertyToMutate,
                });
            }
        },
    },
};
</script>

<style lang="scss">
.v-input--switch {
    margin-top: 0 !important;
    padding-top: 0 !important;

    .v-input__slot {
        margin-bottom: 0 !important;
        width: auto !important;
        cursor: default !important;
        max-width: fit-content;

        .v-label {
            cursor: default;
            margin-bottom: 0 !important;
        }
    }

    .v-messages {
        min-height: 0 !important;
    }
}
</style>
